// `jcr` is the only source that needs a named constant: it's the branch discriminator between
// Magnolia's own delivery API and the backend-driven external-commerce endpoint. External source
// keys (commercetools, salesforce-sfcc, emporix, …) are passed through verbatim, so they don't
// need to be enumerated here.
export const SHOP_SOURCES = {
    JCR: "jcr",
};
